import { IGridServerSideDatasource, ISingleButtonRendererParams, ICellRendererParams } from "@samc/centricity-core";

export interface INotificationTabGridParams {
  dataSource: IGridServerSideDatasource | undefined;
  tabTitle: string;
  rowCount: number;
  rowCountBadgeClasses: string;
  initialize: boolean;
  disabled: boolean;
}

export interface IAutosaveNotificationResponse {
  id: number;
  packageName: string;
  importProcessId: number;
  importProcessName: string;
}

export const Keys = {
  Escape: 'Escape'
};